<template>
  <div id="toggle">
    <label class="switch">
      <input
        type="checkbox"
        :checked="checked"
        @change="$emit('change', $event.target.checked)"
        id="togBtn"
      />
      <div class="slider round"></div>
    </label>
  </div>
</template>

<script>
export default {
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    checked: Boolean
  }
};
</script>


<style>
#toggle .switch {
  position: relative;
  display: flex;
  justify-content: flex-start;
  width: 184px;
  height: 44px;
  margin-top: 13px;
  z-index: 9999;
}

#toggle .switch input {
  display: none;
  z-index: 9999;
}

#toggle .slider {
  position: absolute !important;
  cursor: pointer !important;
  top: 0 !important;
  z-index: 9999 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(41, 204, 65, 1);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}

#toggle .slider:before {
  position: absolute;
  content: "";
  height: 34px;
  width: 34px;
  left: 6px;
  bottom: 4.6px;
  z-index: 9999;
  background: #ffbd2e;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

#toggle input:checked + .slider {
  background: #ff6059;
}

#toggle input:focus + .slider {
  box-shadow: 0 0 1px #37474f;
}

#toggle input:checked + .slider:before {
  -webkit-transform: translateX(138px);
  -ms-transform: translateX(138px);
  transform: translateX(138px);
}

#toggle .slider:after {
  content: "finish";
  z-index: 9999 !important;
  width: 100% !important;
  font-weight: 600;
  color: white;
  display: block !important;
  position: absolute !important;
  transform: translate(-11%, -50%) !important;
  top: 50% !important;
  left: 50% !important;
  font-size: 0.94rem !important;
  letter-spacing: 1 !important;
}

#toggle input:checked + .slider:after {
  content: "reset";
  letter-spacing: 1.2;
}
</style>
